import React from 'react'

const Icon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.83871 3.53846C6.12608 3.53846 5.54839 4.11246 5.54839 4.82051V19.1795C5.54839 19.8875 6.12608 20.4615 6.83871 20.4615H17.1613C17.8739 20.4615 18.4516 19.8875 18.4516 19.1795V9.14049C18.4516 8.80672 18.3206 8.48611 18.0864 8.2468L13.8594 3.92682C13.6164 3.67854 13.2827 3.53846 12.9342 3.53846H6.83871ZM4 4.82051C4 3.26279 5.27093 2 6.83871 2H12.9342C13.701 2 14.4351 2.30817 14.9696 2.85439L19.1966 7.17437C19.7118 7.70085 20 8.4062 20 9.14049V19.1795C20 20.7372 18.7291 22 17.1613 22H6.83871C5.27093 22 4 20.7372 4 19.1795V4.82051Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.12903 15.0768C8.12903 15.5017 8.47565 15.8461 8.90323 15.8461H15.0968C15.5243 15.8461 15.871 15.5017 15.871 15.0768C15.871 14.652 15.5243 14.3076 15.0968 14.3076H8.90323C8.47565 14.3076 8.12903 14.652 8.12903 15.0768Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.12903 10.9744C8.12903 11.3992 8.47565 11.7436 8.90323 11.7436H12C12.4276 11.7436 12.7742 11.3992 12.7742 10.9744C12.7742 10.5495 12.4276 10.2051 12 10.2051H8.90323C8.47565 10.2051 8.12903 10.5495 8.12903 10.9744Z"
      fill="currentColor"
    />
  </svg>
)

export default Icon
